import { StripeError } from '@stripe/stripe-js'
import {
  PaymentMethod,
  PaymentSystem,
  StripeErrorCode,
} from '~/shared/constants/paymentConstants'
import { ScreenName, eventLogger } from '~/shared/services/eventLogger'
import { TProductId } from '~/shared/types/subscriptionsTypes'

export const logFailedPayment = ({
  email,
  productId,
  paymentResponse: { type, code, message, decline_code: declineCode },
  paymentMethod,
  paymentSystem,
  stripeAccountName,
  stripeAccountId,
  screenName,
  priceDetails,
  isForce3DS,
}: {
  email: string
  productId: TProductId
  paymentResponse: StripeError
  paymentMethod: PaymentMethod
  paymentSystem: PaymentSystem
  stripeAccountName?: string
  stripeAccountId?: string
  screenName: ScreenName
  priceDetails: { price: number; trial?: boolean; currency?: string }
  isForce3DS: boolean
}): void => {
  const errorCode =
    code === StripeErrorCode.CARD_DECLINED ? `${code}:${declineCode}` : code

  eventLogger.logPurchaseFailed({
    email,
    productId,
    priceDetails,
    error: { type, code: errorCode, description: message },
    paymentMethod,
    paymentSystem,
    stripeAccountName,
    stripeAccountId,
    screenName,
    isForce3DS,
  })
}
